import React from 'react';
import classNames from 'classnames/bind';
import { Button } from '@carnica/ui-kit';
import styles from "./styles.pcss";
import { isIOS } from "../../../../../utils/os";
var cn = classNames.bind(styles);
export var AppBannerLayout = function AppBannerLayout(_ref) {
  var children = _ref.children,
    href = _ref.href;
  if (isIOS) {
    return /*#__PURE__*/React.createElement(Button, {
      className: cn('wrapper', 'iOS'),
      href: href,
      tagName: "a",
      "data-t-id": "components-AppBannerLayout"
    }, children);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper')
  }, children);
};